module.exports = __webpack_public_path__ + "img/card.5014f714.jpg";